import llmsAgenticAiIcon from "../../src/resources/images/courses-dropdown/llmsAgenticAi.svg";
import renaissancePlusIcon from "../../src/resources/images/courses-dropdown/renaissancePlus.svg";
import systemDesignIcon from "../../src/resources/images/courses-dropdown/systemDesign.svg";
import javaSpringBootIcon from "../../src/resources/images/courses-dropdown/javaSpringBoot.svg";
import dsaIcon from "../../src/resources/images/courses-dropdown/dsaElectron.svg";
import cppIcon from "../../src/resources/images/courses-dropdown/cppLogo.svg";
import pythonIcon from "../../src/resources/images/courses-dropdown/pythonLogo.svg";
import { NAV_LINK_CONSTANTS } from "../../src/Constants/NavLinksContants";

const header = <h3 className="PPNameHeader">Programming Pathshala</h3>;

const courses = [
    {
        id: 1,
        icon: llmsAgenticAiIcon,
        name: "LLMs, Deep Learning & Agentic AI",
        subtitle: "For Next Gen Builders",
        badge: "New",
        link: NAV_LINK_CONSTANTS.AGENTIC_AI_PAGE_URL,
    },
    {
        id: 2,
        icon: renaissancePlusIcon,
        name: "Renaissance Plus",
        subtitle: "DSA + MERN + System Design + SpringBoot + Agentic AI",
        link: NAV_LINK_CONSTANTS.RENAISSANCE_COURSE_URL,
    },
    {
        id: 3,
        icon: systemDesignIcon,
        name: "System Design",
        subtitle: "LLD & Concurrency + HLD",
        link: NAV_LINK_CONSTANTS.LOW_LEVEL_DESIGN_COURSE_URL,
    },
    {
        id: 4,
        icon: javaSpringBootIcon,
        name: "Java SpringBoot",
        subtitle: "For Backend Development",
        link: NAV_LINK_CONSTANTS.JAVA_SPRINGBOOT_COURSE_URL,
    },
    {
        id: 5,
        icon: dsaIcon,
        name: "Data Structures & Algorithms",
        subtitle: "Ace Coding Interview Rounds",
        link: NAV_LINK_CONSTANTS.DSA_AND_ALGORITHMS_ESSENTIALS_COURSE_URL,
    },
    {
        id: 6,
        icon: cppIcon,
        name: "C++ Programming Essentials",
        subtitle: "Get Started with Programming Fundamentals",
        link: NAV_LINK_CONSTANTS.BEGIN_WITH_CPP_COURSE_URL,
    },
    {
        id: 7,
        icon: pythonIcon,
        name: "Python Mastery",
        subtitle: "For ML & Web Development",
        link: NAV_LINK_CONSTANTS.BEGIN_WITH_PYTHON_COURSE_URL,
    },
];

export { header, courses };
